import { render, staticRenderFns } from "./returnReason.vue?vue&type=template&id=8cdc481c&"
import script from "./returnReason.vue?vue&type=script&lang=js&"
export * from "./returnReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports